import { render, staticRenderFns } from "./CertDocs.vue?vue&type=template&id=164d097a&scoped=true"
import script from "./CertDocs.vue?vue&type=script&lang=js"
export * from "./CertDocs.vue?vue&type=script&lang=js"
import style0 from "./CertDocs.vue?vue&type=style&index=0&id=164d097a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164d097a",
  null
  
)

export default component.exports